import path from "@const/path";

export function getSectionURL(section_idx: number, section_child_idx: number | undefined) {
    if (typeof section_child_idx === 'number') {
        return `${path.section}/${section_idx}/${section_child_idx}`;
    } else {
        return "";
    }
}